import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extension-privacy-policy',
  templateUrl: './extension-privacy-policy.component.html',
  styleUrls: ['./extension-privacy-policy.component.css']
})
export class ExtensionPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
